import sessionService from "services/session/sessionService";
import seedrandom from "seedrandom";

export const isTrackingEnabled = async (trackingRatio: number) => {
  const sessionId = (await sessionService.getSession()).session;
  const getSessionScore = seedrandom(sessionId);

  return getSessionScore() <= trackingRatio;
};
